function initProductAssuranceSplides(scope) {
  var root = scope || document;
  if (typeof Splide === 'undefined') return;
  var allowAutoplay = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.querySelectorAll('.product-assurance-splide:not([data-assurance-splide-mounted])').forEach(function (el) {
    el.dataset.assuranceSplideMounted = 'true';
    new Splide(el, {
      type: 'loop',
      perPage: 1,
      perMove: 1,
      gap: 0,
      arrows: false,
      pagination: true,
      drag: true,
      autoplay: allowAutoplay,
      interval: 3000,
      pauseOnHover: true,
      pauseOnFocus: true,
    }).mount();
  });
}

function initSaleCountdowns(scope) {
  var root = scope || document;

  root.querySelectorAll('[data-sale-countdown]:not([data-sale-countdown-mounted])').forEach(function (countdownEl) {
    countdownEl.dataset.saleCountdownMounted = 'true';

    var isBadge = countdownEl.hasAttribute('data-sale-countdown-badge');
    var wrapper = isBadge ? null : countdownEl.closest('[data-sale-countdown-active]');
    var atcContainer = wrapper ? wrapper.querySelector('.atc-button-container') : null;
    var notifyContainer = wrapper ? wrapper.querySelector('[data-sale-countdown-notify]') : null;
    var display = countdownEl.querySelector('[data-sale-countdown-display]') || countdownEl;
    var expiresAt = new Date(countdownEl.dataset.saleExpires);
    var intervalId;

    if (Number.isNaN(expiresAt.getTime())) return;
    if (display === countdownEl && !countdownEl.hasAttribute('data-sale-countdown-display')) return;

    function pad(value) {
      return String(value).padStart(2, '0');
    }

    function formatCountdown(diff) {
      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      if (days > 0) {
        var dayUnit = (window.themeVariables && window.themeVariables.strings && window.themeVariables.strings.countdownDayUnit) || 'j';
        return days + dayUnit + ' ' + pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
      }

      return pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
    }

    function onExpired() {
      if (intervalId) {
        clearInterval(intervalId);
      }

      if (isBadge) {
        var badgeList = countdownEl.closest('badge-list');
        countdownEl.remove();

        if (badgeList && badgeList.children.length === 0) {
          badgeList.remove();
        }

        return;
      }

      countdownEl.hidden = true;

      if (atcContainer) {
        atcContainer.hidden = false;
      }

      if (notifyContainer) {
        notifyContainer.hidden = true;
      }

      if (wrapper) {
        wrapper.classList.remove('atc-sale-countdown-wrapper--active');
        wrapper.removeAttribute('data-sale-countdown-active');

        var buyButtons = wrapper.closest('buy-buttons');
        if (buyButtons) {
          var paymentButton = buyButtons.querySelector('.shopify-payment-button');
          if (paymentButton) {
            paymentButton.style.display = '';
          }
        }

        document.querySelectorAll('[data-sale-countdown-hidden]').forEach(function (element) {
          element.hidden = false;
          element.removeAttribute('data-sale-countdown-hidden');
        });
      }
    }

    function updateCountdown() {
      var diff = expiresAt.getTime() - Date.now();

      if (diff <= 0) {
        onExpired();
        return;
      }

      display.textContent = formatCountdown(diff);
    }

    updateCountdown();
    intervalId = setInterval(updateCountdown, 1000);
  });
}

function watchForSaleCountdowns() {
  if (watchForSaleCountdowns.started || typeof MutationObserver === 'undefined') return;
  watchForSaleCountdowns.started = true;

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];
        if (!node || node.nodeType !== 1) continue;

        var isCountdown = node.matches && node.matches('[data-sale-countdown]:not([data-sale-countdown-mounted])');
        var hasCountdown = !isCountdown && node.querySelector && node.querySelector('[data-sale-countdown]:not([data-sale-countdown-mounted])');
        if (!isCountdown && !hasCountdown) continue;

        initSaleCountdowns(isCountdown ? node.parentElement || document : node);
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
}

watchForSaleCountdowns();

document.addEventListener('DOMContentLoaded', function () {
  initProductAssuranceSplides();
  initSaleCountdowns();
});

document.addEventListener(
  'dialog:after-show',
  function (event) {
    initProductAssuranceSplides(event.target);
    initSaleCountdowns(event.target);
  },
  true
);

function activateCareerFormScripts(modal) {
  if (!modal || !modal.classList.contains('careers-modal')) return;

  var formContainer = modal.querySelector('[data-career-form]');
  if (!formContainer) return;

  formContainer.querySelectorAll('script').forEach(function (oldScript) {
    var newScript = document.createElement('script');
    Array.from(oldScript.attributes).forEach(function (attr) {
      newScript.setAttribute(attr.name, attr.value);
    });
    newScript.textContent = oldScript.textContent;
    oldScript.parentNode.replaceChild(newScript, oldScript);
  });
}

document.addEventListener(
  'dialog:after-show',
  function (event) {
    activateCareerFormScripts(event.target);
  },
  true
);

document.addEventListener(
  'product:rerender',
  function () {
    requestAnimationFrame(function () {
      initProductAssuranceSplides();
      initSaleCountdowns();
    });
  },
  true
);

document.addEventListener('facet:update', function () {
  document.documentElement.addEventListener(
    'theme:loading:end',
    function () {
      requestAnimationFrame(function () {
        initProductAssuranceSplides();
        initSaleCountdowns();
      });
    },
    { once: true }
  );
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.splide-slider-images').forEach(function (el) {
    const splide = new Splide(el, {
      type: 'loop',
      perPage: 3,
      perMove: 1,
      gap: '1rem',
      arrows: true,
      pagination: false,
      breakpoints: {
        1024: { perPage: 2 },
        768: { perPage: 2 }
      }
    });

    // Cherche une progress bar dans CE slider uniquement
    const progressBar = el.closest('.slider-images-wrapper')?.querySelector('.my-slider-progress-bar');

    if (progressBar) {
      splide.on('mounted move', function () {
        const end = splide.Components.Controller.getEnd() + 1;
        const index = splide.index + 1;
        const progress = Math.min((index / end) * 100, 100);
        progressBar.style.width = progress + '%';
      });
    }

    splide.mount();
  });

  const galleryMobileQuery = window.matchMedia('(max-width: 768px)');

  function mountGallerySliders() {
    const mobile = galleryMobileQuery.matches;

    document.querySelectorAll('.mto-gallery__splide').forEach(function (el) {
      if (mobile) {
        if (el._mtoSplide) {
          el._mtoSplide.destroy();
          el._mtoSplide = null;
        }
        return;
      }
      if (el._mtoSplide || typeof Splide === 'undefined') return;

      const slides = el.querySelectorAll('.splide__slide');
      if (!slides.length) return;

      const full = el.closest('.mto-gallery__grid')?.classList.contains('mto-gallery__grid--full');
      const perPage = full ? Math.min(4, slides.length) : 3;

      const splide = new Splide(el, {
        type: slides.length > perPage ? 'loop' : 'slide',
        perPage: perPage,
        perMove: 1,
        gap: '16px',
        arrows: false,
        pagination: false,
        breakpoints: {
          1024: { perPage: Math.min(2, slides.length) }
        }
      });

      const note = el.parentElement?.querySelector('.mto-gallery__note');
      if (note && !note.dataset.arrowsBound) {
        note.querySelector('.mto-gallery__arrow--prev')?.addEventListener('click', function () { el._mtoSplide?.go('<'); });
        note.querySelector('.mto-gallery__arrow--next')?.addEventListener('click', function () { el._mtoSplide?.go('>'); });
        note.dataset.arrowsBound = 'true';
      }
      splide.mount();
      el._mtoSplide = splide;
    });

    document.querySelectorAll('.mto-gallery__splide-mobile').forEach(function (el) {
      if (!mobile) {
        if (el._mtoSplide) {
          el._mtoSplide.destroy();
          el._mtoSplide = null;
        }
        return;
      }
      if (el._mtoSplide || typeof Splide === 'undefined') return;

      const slides = el.querySelectorAll('.splide__slide');
      if (!slides.length) return;
      const total = slides.length;
      const counter = el.parentElement?.querySelector('.mto-gallery__counter');
      const splide = new Splide(el, {
        type: 'loop',
        perMove: 1,
        fixedWidth: '65%',
        gap: '1.25rem',
        arrows: false,
        pagination: false
      });

      const pad = function (n) { return String(n).padStart(2, '0'); };
      const updateCounter = function () {
        if (!counter) return;
        counter.textContent = pad(splide.index + 1) + ' / ' + pad(total);
      };

      splide.on('mounted move', updateCounter);
      const nav = el.parentElement;
      if (nav && !nav.dataset.arrowsBound) {
        nav.querySelector('.mto-gallery__arrow--prev')?.addEventListener('click', function () { el._mtoSplide?.go('<'); });
        nav.querySelector('.mto-gallery__arrow--next')?.addEventListener('click', function () { el._mtoSplide?.go('>'); });
        nav.dataset.arrowsBound = 'true';
      }
      splide.mount();
      el._mtoSplide = splide;
    });
  }

  mountGallerySliders();
  galleryMobileQuery.addEventListener('change', mountGallerySliders);

  const stepsQuery = window.matchMedia('(max-width: 1024px)');

  function updateStepsPreview() {
    document.querySelectorAll('.mto-steps-wrap').forEach(function (wrap) {
      const list = wrap.querySelector('.mto-steps');
      const items = list.querySelectorAll('.mto-steps__item');
      if (!stepsQuery.matches || wrap.classList.contains('is-open') || items.length < 2) {
        list.style.maxHeight = '';
        return;
      }
      const gap = parseFloat(getComputedStyle(list).rowGap) || 0;
      list.style.maxHeight = (items[0].offsetHeight + gap + items[1].offsetHeight / 2) + 'px';
    });
  }

  document.querySelectorAll('.mto-steps__toggle').forEach(function (button) {
    button.addEventListener('click', function () {
      const wrap = button.closest('.mto-steps-wrap');
      const open = wrap.classList.toggle('is-open');
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      const label = button.querySelector('span');
      if (label) label.textContent = open ? button.dataset.labelHide : button.dataset.labelShow;
      updateStepsPreview();
    });
  });

  updateStepsPreview();
  stepsQuery.addEventListener('change', updateStepsPreview);
});






document.addEventListener('DOMContentLoaded', function () {
    const splide = new Splide('#splide-selection-produits', {
      type: 'loop',
      perPage: 4,
      perMove: 1,
      gap: '1rem',
      arrows: true,
      pagination: false,
      breakpoints: {
        1024: { perPage: 3 },
        768: { perPage: 2 }
      }
    });

    splide.mount();
  });
console.log("Custom JS bien chargé ✅");

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.collections-slider').forEach(function (slider) {
    const list = slider.querySelector('.collections-slider__list');
    const prev = slider.querySelector('.navigation_articles .prev');
    const next = slider.querySelector('.navigation_articles .next');
    if (!list || !prev || !next) return;

    function scrollStep() {
      return Math.max(120, Math.floor(list.clientWidth * 0.65));
    }

    var epsilon = 2;

    function updateArrows() {
      var maxScroll = list.scrollWidth - list.clientWidth;
      var canScroll = maxScroll > epsilon;
      slider.classList.toggle('is-scrollable', canScroll);

      if (!canScroll) {
        prev.classList.add('disabled');
        next.classList.add('disabled');
        prev.setAttribute('aria-disabled', 'true');
        next.setAttribute('aria-disabled', 'true');
        prev.setAttribute('hidden', '');
        next.setAttribute('hidden', '');
        slider.classList.remove('is-faded-left', 'is-faded-right');
        return;
      }

      var atStart = list.scrollLeft <= epsilon;
      var atEnd = list.scrollLeft >= maxScroll - epsilon;
      prev.classList.toggle('disabled', atStart);
      next.classList.toggle('disabled', atEnd);
      prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
      if (atStart) prev.setAttribute('hidden', '');
      else prev.removeAttribute('hidden');
      if (atEnd) next.setAttribute('hidden', '');
      else next.removeAttribute('hidden');
      slider.classList.toggle('is-faded-left', !atStart);
      slider.classList.toggle('is-faded-right', !atEnd);
    }

    function isActiveFullyVisible(active) {
      var listRect = list.getBoundingClientRect();
      var itemRect = active.getBoundingClientRect();
      return itemRect.left >= listRect.left - 1 && itemRect.right <= listRect.right + 1;
    }

    function scrollActiveIntoView(behavior) {
      var active = list.querySelector('.collections-slider__list-item.active');
      if (!active) return;
      if (isActiveFullyVisible(active)) {
        updateArrows();
        return;
      }
      var listRect = list.getBoundingClientRect();
      var itemRect = active.getBoundingClientRect();
      var itemLeft = itemRect.left - listRect.left + list.scrollLeft;
      var maxScroll = Math.max(0, list.scrollWidth - list.clientWidth);
      var target = itemLeft - (list.clientWidth - active.offsetWidth) / 2;
      list.scrollTo({
        left: Math.max(0, Math.min(target, maxScroll)),
        behavior: behavior || 'smooth'
      });
      updateArrows();
    }

    prev.addEventListener('click', function () {
      if (prev.classList.contains('disabled')) return;
      list.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      if (next.classList.contains('disabled')) return;
      list.scrollBy({ left: scrollStep(), behavior: 'smooth' });
    });

    list.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(updateArrows).observe(list);
    }
    updateArrows();
    scrollActiveIntoView('smooth');

    var images = list.querySelectorAll('img');
    if (images.length) {
      Promise.all(Array.prototype.map.call(images, function (img) {
        if (img.complete) return Promise.resolve();
        return new Promise(function (resolve) {
          img.addEventListener('load', resolve, { once: true });
          img.addEventListener('error', resolve, { once: true });
        });
      })).then(function () {
        scrollActiveIntoView('smooth');
      });
    }
  });
});

document.querySelectorAll('select').forEach(select => {
  select.addEventListener('change', () => {
    if (select.value === '') {
      select.style.fontWeight = 'normal';
    } else {
      select.style.fontWeight = 'bold';
    }
  });

  // Initialiser le style au chargement
  if (select.value === '') {
    select.style.fontWeight = 'normal';
  } else {
    select.style.fontWeight = 'bold';
  }
});

// Pop-up, showroom & carrieres pages — US/JP variants (?country=us|jp)
document.addEventListener('DOMContentLoaded', function () {
  var params = new URLSearchParams(window.location.search);
  var country = (params.get('country') || '').toLowerCase();
  if (country !== 'us' && country !== 'jp') return;

  document.querySelectorAll('product-card[data-country-' + country + '-price], product-card[data-country-' + country + '-url]').forEach(function (card) {
    var url = card.getAttribute('data-country-' + country + '-url');
    var price = card.getAttribute('data-country-' + country + '-price');

    if (url) {
      card.querySelectorAll('a[href]').forEach(function (link) {
        link.setAttribute('href', url);
      });
      card.querySelectorAll('.product-card__quick-add-button, product-form, quick-buy-modal').forEach(function (el) {
        el.remove();
      });
    }

    if (price) {
      var priceList = card.querySelector('price-list');
      if (priceList) {
        var salePrice = document.createElement('sale-price');
        var current = priceList.querySelector('sale-price');
        salePrice.className = current ? current.className : 'text-subdued';
        salePrice.textContent = price;
        priceList.replaceChildren(salePrice);
      }
    }
  });

  var path = window.location.pathname;
  var isPopUpOrShowroom = path.includes('/pages/pop-up') || path.includes('/pages/showroom');
  var isCarrieres = path.includes('/pages/carrieres') || path.includes('/carrieres');
  if (!isPopUpOrShowroom && !isCarrieres) return;

  var hideSelectors = '.header__primary-nav, .header__secondary-nav, .footer__block--links, .section_showroom, .shopify-section--announcement-bar, .shopify-section-group-footer-group';
  if (isPopUpOrShowroom) hideSelectors += ', .section-creations, .rdv-image';

  document.querySelectorAll(hideSelectors).forEach(function (el) {
    el.classList.add('hidden');
  });

  document.documentElement.style.setProperty('--announcement-bar-height', '0px');

  document.querySelectorAll('.header__logo').forEach(function (logo) {
    logo.setAttribute('href', params.get('country') === 'us' ? 'https://us.michinoparis.com/' : 'https://jp.michinoparis.com/');
  });
});

// Variant picker: keep data-option-value in the store's primary language (French) on every locale,
// and fill each .popover__value-option-image swatch from the product metafield maps rendered by
// variant-picker.liquid (script[data-option-images]). Liquid can only render the active locale, so
// we fetch the unprefixed /products/{handle}.js — always served in the primary language — and use
// its French option names/values both to rewrite the attribute and to look up the image maps.
(function () {
  var primaryProductCache = {};

  // On mobile the theme moves the open x-popover to <body> (shouldAppendToBody), detaching the
  // labels from their <variant-picker>. Trace the picker back through the input's form id.
  function pickerForLabel(label) {
    var picker = label.closest('variant-picker');
    if (picker) return picker;

    var input = label.querySelector('input[form]');
    if (!input) return null;
    return document.querySelector('variant-picker[form-id="' + input.getAttribute('form') + '"]');
  }

  function applyPrimaryLocaleData(picker, labels) {
    var handle = picker.getAttribute('handle');
    if (!handle) return;

    var imageMaps = null;
    var imagesScript = picker.querySelector('script[data-option-images]');
    if (imagesScript) {
      try {
        imageMaps = JSON.parse(imagesScript.textContent);
      } catch (error) {
        imageMaps = null;
      }
    }

    if (!primaryProductCache[handle]) {
      primaryProductCache[handle] = fetch('/products/' + handle + '.js').then(function (response) {
        return response.json();
      });
    }

    primaryProductCache[handle]
      .then(function (product) {
        // The popovers may be detached from the picker (moved to <body> on mobile),
        // so reach them through the picker's aria-controls buttons.
        picker.querySelectorAll('[aria-controls]').forEach(function (control) {
          var popover = document.getElementById(control.getAttribute('aria-controls'));
          if (!popover || !popover.hasAttribute('data-option-name')) return;

          var option = product.options[parseInt(popover.dataset.optionPosition, 10) - 1];
          if (option) popover.dataset.optionName = option.name;
        });

        labels.forEach(function (label) {
          var input = label.querySelector('input[data-option-position]');
          if (!input) return;

          var option = product.options[parseInt(input.dataset.optionPosition, 10) - 1];
          if (!option) return;

          var frenchValue = option.values[parseInt(label.dataset.optionValueIndex, 10)];
          if (frenchValue === undefined) frenchValue = label.dataset.optionValue;
          label.dataset.optionValue = frenchValue;

          var span = label.querySelector('.popover__value-option-image');
          if (!span || !imageMaps) return;

          var map = imageMaps[input.dataset.optionPosition];
          var imageUrl = map ? map[frenchValue.toUpperCase()] : null;
          if (imageUrl) {
            span.style.backgroundImage = 'url("' + imageUrl + '")';
          }
        });
      })
      .catch(function () {});
  }

  function localizeVariantOptionValues(scope) {
    var root = scope || document;
    var labelsByPicker = new Map();

    root.querySelectorAll('label[data-option-value][data-option-value-index]').forEach(function (label) {
      var picker = pickerForLabel(label);
      if (!picker) return;

      if (!labelsByPicker.has(picker)) labelsByPicker.set(picker, []);
      labelsByPicker.get(picker).push(label);
    });

    // Popovers without processable labels still need their data-option-name localized.
    root.querySelectorAll('x-popover[data-option-name]').forEach(function (popover) {
      var picker = popover.closest('variant-picker');
      if (!picker) {
        var input = popover.querySelector('input[form]');
        if (input) picker = document.querySelector('variant-picker[form-id="' + input.getAttribute('form') + '"]');
      }
      if (picker && !labelsByPicker.has(picker)) labelsByPicker.set(picker, []);
    });

    labelsByPicker.forEach(function (labels, picker) {
      applyPrimaryLocaleData(picker, labels);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    localizeVariantOptionValues();
  });

  // Quick-buy drawers and variant changes re-render the picker, wiping the rewritten attributes.
  document.addEventListener('dialog:after-show', function (event) {
    localizeVariantOptionValues(event.target);
  }, true);

  document.addEventListener('product:rerender', function () {
    requestAnimationFrame(function () {
      localizeVariantOptionValues();
    });
  }, true);
})();

// Swishlist: open theme cart drawer after add-to-cart from wishlist page.
// Enter `openCartDrawer` in Swishlist → Cart drawer trigger function.
window.openCartDrawer = function openCartDrawer() {
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  var cartDrawer = document.getElementById('cart-drawer');
  if (cartDrawer && typeof cartDrawer.show === 'function') {
    cartDrawer.show();
  }
};

// Product linked swatches: preview option name next to the label on hover (sizes + colors).
(function () {
  function bindOptionNameHover(scope) {
    var root = scope || document;

    root.querySelectorAll('.product-linked-variant-picker__options--colors, .product-linked-variant-picker__options--size-images').forEach(function (list) {
      if (list.dataset.optionHoverBound === 'true') return;
      list.dataset.optionHoverBound = 'true';

      var fieldset = list.closest('fieldset');
      var nameEl = fieldset
        ? fieldset.querySelector('.product-linked-variant-picker__selected-name')
        : null;
      if (!nameEl) return;

      var defaultName = nameEl.getAttribute('data-default-option-name') || nameEl.textContent.trim();

      list.querySelectorAll('.product-linked-variant-picker__color-option').forEach(function (option) {
        option.addEventListener('mouseenter', function () {
          var optionName = option.getAttribute('data-option-name');
          if (optionName) nameEl.textContent = optionName;
        });
      });

      var moreBtn = list.querySelector('.product-linked-variant-picker__more-colors');
      if (moreBtn) {
        moreBtn.addEventListener('mouseenter', function () {
          nameEl.textContent = defaultName;
        });
      }

      list.addEventListener('mouseleave', function () {
        nameEl.textContent = defaultName;
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    bindOptionNameHover();
  });

  document.addEventListener('product:rerender', function () {
    requestAnimationFrame(function () {
      bindOptionNameHover();
    });
  }, true);
})();

// Color drawer tabs (custom, so clicks still work after the drawer moves to <body>)
document.addEventListener('click', function (event) {
  var tab = event.target.closest('[data-color-drawer-tab]');
  if (!tab) return;

  var root = tab.closest('.color-drawer-tabs');
  if (!root) return;

  var index = tab.getAttribute('data-color-drawer-tab');
  root.querySelectorAll('[data-color-drawer-tab]').forEach(function (button) {
    button.setAttribute('aria-selected', button === tab ? 'true' : 'false');
  });
  root.querySelectorAll('[data-color-drawer-panel]').forEach(function (panel) {
    panel.hidden = panel.getAttribute('data-color-drawer-panel') !== index;
  });
});

(function () {
  if (window.customElements.get('collection-infinite-scroll')) return;

  var AJAX_PARAMS = ['view', 'count', 'hide_info', 'stacked', 'block'];

  class CollectionInfiniteScroll extends HTMLElement {
    connectedCallback() {
      this._loading = false;
      this._emptyPages = 0;
      this._nextUrl = this.getAttribute('data-next-url');
      this._sectionId = this.getAttribute('data-section-id');
      this._listId = this.getAttribute('data-list-id') || this.getAttribute('data-product-list-id');
      this._responseListId = this.getAttribute('data-response-list-id') || this._listId;

      if (!this._nextUrl || !this._listId) return;

      this._abortController = new AbortController();
      this._observer = new IntersectionObserver(this._onIntersect.bind(this), {
        rootMargin: '800px 0px'
      });
      this._observer.observe(this);
    }

    disconnectedCallback() {
      if (this._observer) this._observer.disconnect();
      if (this._abortController) this._abortController.abort();
    }

    _onIntersect(entries) {
      if (this.offsetParent === null) return;
      if (entries.some(function (entry) { return entry.isIntersecting; })) {
        this._loadNextPage();
      }
    }

    _preserveAjaxParams(nextUrl) {
      var next = new URL(nextUrl, window.location.href);
      var current = new URL(this._nextUrl, window.location.href);

      AJAX_PARAMS.forEach(function (param) {
        if (current.searchParams.has(param)) {
          next.searchParams.set(param, current.searchParams.get(param));
        }
      });

      return next.toString();
    }

    _extractNextUrl(doc) {
      var nextComponent = doc.querySelector('collection-infinite-scroll');
      if (nextComponent && nextComponent.getAttribute('data-next-url')) {
        return nextComponent.getAttribute('data-next-url');
      }

      var nextLink = doc.querySelector('link[rel="next"], a[rel="next"]');
      if (nextLink && nextLink.getAttribute('href')) {
        return this._preserveAjaxParams(nextLink.getAttribute('href'));
      }

      return '';
    }

    _loadNextPage() {
      if (this._loading || !this._nextUrl) return;

      this._loading = true;
      this.setAttribute('aria-busy', 'true');

      var url = new URL(this._nextUrl, window.location.href);
      if (this._sectionId) {
        url.searchParams.set('section_id', this._sectionId);
      }

      fetch(url.toString(), { signal: this._abortController.signal })
        .then(function (response) {
          if (!response.ok) throw new Error('Failed to load next page');
          return response.text();
        }.bind(this))
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var list = document.getElementById(this._listId);
          var newList = doc.getElementById(this._responseListId);
          var appended = 0;

          if (list && newList) {
            var existingHandles = {};
            list.querySelectorAll('product-card[handle]').forEach(function (card) {
              existingHandles[card.getAttribute('handle')] = true;
            });

            Array.from(newList.children).forEach(function (child) {
              if (child.classList.contains('injected-image')) return;
              if (child.hasAttribute('handle') && existingHandles[child.getAttribute('handle')]) return;

              var node = document.importNode(child, true);
              if (node.nodeType === Node.ELEMENT_NODE) {
                node.removeAttribute('reveal-on-scroll');
                node.style.opacity = '1';
              }
              list.appendChild(node);
              appended += 1;
            });

            if (typeof initProductAssuranceSplides === 'function') {
              initProductAssuranceSplides(list);
            }
            if (typeof initSaleCountdowns === 'function') {
              initSaleCountdowns(list);
            }
          }

          var nextUrl = this._extractNextUrl(doc);

          if (appended === 0 && nextUrl && this._emptyPages < 3) {
            this._emptyPages += 1;
            this._nextUrl = nextUrl;
            this.setAttribute('data-next-url', nextUrl);
            this._loading = false;
            this.removeAttribute('aria-busy');
            this._loadNextPage();
            return;
          }

          this._emptyPages = 0;
          this._loading = false;
          this.removeAttribute('aria-busy');

          if (nextUrl) {
            this._nextUrl = nextUrl;
            this.setAttribute('data-next-url', nextUrl);
            this._observer.unobserve(this);
            this._observer.observe(this);
          } else {
            this._nextUrl = '';
            this._observer.disconnect();
            this.setAttribute('data-complete', '');
          }
        }.bind(this))
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          this._loading = false;
          this.removeAttribute('aria-busy');
        }.bind(this));
    }
  }

  window.customElements.define('collection-infinite-scroll', CollectionInfiniteScroll);
})();

(function () {
  var desktopQuery = window.matchMedia('(min-width: 769px)');
  var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var accordionStates = new WeakMap();

  function getContent(accordion) {
    return accordion.querySelector('.footer-accordion__content');
  }

  function clearAccordionStyles(content) {
    if (!content) return;
    content.style.height = '';
    content.style.opacity = '';
    content.style.overflow = '';
    content.style.transition = '';
  }

  function stopAccordionAnimation(accordion) {
    var state = accordionStates.get(accordion);
    if (!state) return;
    if (state.frame) {
      cancelAnimationFrame(state.frame);
      state.frame = null;
    }
    if (state.fallback) {
      clearTimeout(state.fallback);
      state.fallback = null;
    }
    if (state.onEnd && state.content) {
      state.content.removeEventListener('transitionend', state.onEnd);
    }
  }

  function setExpanded(accordion, expanded) {
    accordion.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    if (expanded) {
      accordion.setAttribute('open', '');
    } else {
      accordion.removeAttribute('open');
    }
  }

  function animateAccordion(accordion, expand) {
    var content = getContent(accordion);
    if (!content || desktopQuery.matches || reducedMotionQuery.matches) {
      setExpanded(accordion, expand);
      clearAccordionStyles(content);
      return;
    }

    stopAccordionAnimation(accordion);

    var alreadyOpen = accordion.hasAttribute('open');
    var startHeight = alreadyOpen ? content.getBoundingClientRect().height : 0;

    if (expand) {
      accordion.setAttribute('open', '');
      accordion.setAttribute('aria-expanded', 'true');
    } else {
      accordion.setAttribute('aria-expanded', 'false');
      if (!startHeight) startHeight = content.scrollHeight;
    }

    content.style.overflow = 'hidden';
    content.style.transition = 'none';
    content.style.height = startHeight + 'px';
    content.style.opacity = startHeight === 0 ? '0' : '1';
    content.offsetHeight;

    var endHeight = expand ? content.scrollHeight : 0;

    var onEnd = function (event) {
      if (event && event.target !== content) return;
      if (event && event.propertyName && event.propertyName !== 'height') return;
      stopAccordionAnimation(accordion);
      if (expand) {
        clearAccordionStyles(content);
      } else {
        accordion.removeAttribute('open');
        clearAccordionStyles(content);
      }
    };

    var state = {
      content: content,
      onEnd: onEnd,
      frame: null,
      fallback: null
    };
    accordionStates.set(accordion, state);

    state.frame = requestAnimationFrame(function () {
      state.frame = requestAnimationFrame(function () {
        content.style.transition = 'height 0.4s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.3s ease';
        content.style.height = endHeight + 'px';
        content.style.opacity = expand ? '1' : '0';
        content.addEventListener('transitionend', onEnd);
        state.fallback = setTimeout(onEnd, 450);
      });
    });
  }

  function onSummaryClick(event) {
    if (desktopQuery.matches) return;
    event.preventDefault();
    var accordion = event.currentTarget.closest('.footer-accordion');
    if (!accordion) return;
    animateAccordion(accordion, accordion.getAttribute('aria-expanded') !== 'true');
  }

  function bindFooterAccordions(scope) {
    var root = scope || document;
    root.querySelectorAll('.footer-accordion').forEach(function (accordion) {
      var summary = accordion.querySelector('.footer-accordion__summary');
      if (!summary || summary.dataset.footerAccordionBound === 'true') return;
      summary.dataset.footerAccordionBound = 'true';
      summary.addEventListener('click', onSummaryClick);
    });
  }

  function syncFooterAccordions() {
    document.querySelectorAll('.footer-accordion').forEach(function (accordion) {
      stopAccordionAnimation(accordion);
      setExpanded(accordion, desktopQuery.matches);
      clearAccordionStyles(getContent(accordion));
    });
  }

  desktopQuery.addEventListener('change', syncFooterAccordions);
  document.addEventListener('DOMContentLoaded', function () {
    bindFooterAccordions();
    syncFooterAccordions();
  });
  document.addEventListener('shopify:section:load', function (event) {
    bindFooterAccordions(event.target);
    syncFooterAccordions();
  });
})();

(function () {
  function giftBoxBlock(drawer) {
    var id = drawer.getAttribute('data-gift-box-drawer');
    if (!id || !window.CSS || !CSS.escape) {
      return document.querySelector('[data-gift-box="' + id + '"]');
    }
    return document.querySelector('[data-gift-box="' + CSS.escape(id) + '"]');
  }

  function setGiftBoxSelected(block, selected) {
    var checkbox = block.querySelector('[data-gift-box-checkbox]');
    var trigger = block.querySelector('[data-gift-box-open]');
    var added = block.querySelector('[data-gift-box-added]');
    if (!checkbox || !trigger || !added) return;

    checkbox.checked = selected;
    trigger.hidden = selected;
    added.hidden = !selected;

    if (selected) {
      trigger.removeAttribute('aria-controls');
    } else {
      trigger.setAttribute('aria-controls', block.getAttribute('data-gift-box'));
    }
  }

  function focusGiftBoxControl(block) {
    var checkbox = block.querySelector('[data-gift-box-checkbox]');
    var target = checkbox && checkbox.checked
      ? block.querySelector('[data-gift-box-remove]')
      : block.querySelector('[data-gift-box-open]');
    if (!target) return;
    window.setTimeout(function () {
      target.focus();
    }, 0);
  }

  function closeGiftBoxDrawer(drawer, selected) {
    var block = giftBoxBlock(drawer);
    if (block) block.dataset.giftBoxPending = selected ? '1' : '0';
    if (typeof drawer.hide === 'function') {
      drawer.hide();
    } else {
      drawer.removeAttribute('open');
    }
  }

  document.addEventListener('click', function (event) {
    var apply = event.target.closest && event.target.closest('[data-gift-box-apply]');
    var skip = event.target.closest && event.target.closest('[data-gift-box-skip]');
    var remove = event.target.closest && event.target.closest('[data-gift-box-remove]');

    if (apply) {
      event.preventDefault();
      var drawer = apply.closest('[data-gift-box-drawer]');
      if (!drawer) return;
      closeGiftBoxDrawer(drawer, true);
      return;
    }

    if (skip) {
      event.preventDefault();
      var skipDrawer = skip.closest('[data-gift-box-drawer]');
      if (!skipDrawer) return;
      closeGiftBoxDrawer(skipDrawer, false);
      return;
    }

    if (remove) {
      event.preventDefault();
      var block = remove.closest('[data-gift-box]');
      if (!block) return;
      setGiftBoxSelected(block, false);
      focusGiftBoxControl(block);
    }
  });

  document.addEventListener('dialog:after-hide', function (event) {
    var drawer = event.target;
    if (!drawer || !drawer.matches || !drawer.matches('[data-gift-box-drawer]')) return;
    var block = giftBoxBlock(drawer);
    if (!block || !block.hasAttribute('data-gift-box-pending')) return;
    var selected = block.dataset.giftBoxPending === '1';
    delete block.dataset.giftBoxPending;
    setGiftBoxSelected(block, selected);
    focusGiftBoxControl(block);
  }, true);
})();

(function () {
  var FIELD_NAME = '0-1/product_interest';

  function backInStockModals() {
    return document.querySelectorAll('x-modal[id^="back-in-stock-"]');
  }

  function setInputValue(input, sku) {
    if (!input || input.value === sku) return;
    var descriptor = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value');
    if (descriptor && descriptor.set) {
      descriptor.set.call(input, sku);
    } else {
      input.value = sku;
    }
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function setHubSpotField(modal, sku) {
    var api = window.HubSpotFormsV4;
    var host = modal.querySelector('.hs-form-html');
    var formId = host && host.getAttribute('data-form-id');
    if (!api || !api.getForms || !formId) return;

    api.getForms().forEach(function (form) {
      if (!form || !form.setFieldValue) return;
      if (form.getFormId && form.getFormId() !== formId) return;
      Promise.resolve(form.setFieldValue(FIELD_NAME, sku)).catch(function () {});
    });
  }

  function fillModal(modal) {
    var sku = (modal.getAttribute('data-product-sku') || '').trim();
    if (!sku) return;

    var inputs = modal.querySelectorAll('input[name="' + FIELD_NAME + '"], input[name="product_interest"]');
    var needsValue = false;
    inputs.forEach(function (input) {
      if (input.value !== sku) needsValue = true;
    });

    if (inputs.length && !needsValue && modal.dataset.productInterestSku === sku) return;

    inputs.forEach(function (input) {
      setInputValue(input, sku);
    });

    if (modal.dataset.productInterestSku !== sku || needsValue) {
      setHubSpotField(modal, sku);
      modal.dataset.productInterestSku = sku;
    }
  }

  function watchModal(modal) {
    if (modal.dataset.productInterestWatch === 'true') return;
    modal.dataset.productInterestWatch = 'true';

    var observer = new MutationObserver(function () {
      fillModal(modal);
    });
    observer.observe(modal, { childList: true, subtree: true });
    fillModal(modal);
  }

  function watchModals() {
    backInStockModals().forEach(watchModal);
  }

  document.addEventListener('hs-form-event:on-ready', function (event) {
    var api = window.HubSpotFormsV4;
    var form = api && api.getFormFromEvent && api.getFormFromEvent(event);
    var formId = form && form.getFormId && form.getFormId();

    backInStockModals().forEach(function (modal) {
      var host = modal.querySelector('.hs-form-html');
      if (formId && host && host.getAttribute('data-form-id') !== formId) return;
      fillModal(modal);
    });
  });

  document.addEventListener('variant:change', function (event) {
    var productForm = event.target;
    if (!productForm || !productForm.closest) return;

    var section = productForm.closest('.shopify-section');
    var sectionId = section && section.id;
    var variant = event.detail && event.detail.variant;
    var sku = variant && variant.sku ? String(variant.sku) : '';

    backInStockModals().forEach(function (modal) {
      if (sectionId && modal.getAttribute('data-section-id') !== sectionId) return;
      modal.setAttribute('data-product-sku', sku);
      delete modal.dataset.productInterestSku;
      fillModal(modal);
    });
  });

  document.addEventListener('dialog:after-show', function (event) {
    var modal = event.target;
    if (!modal || !modal.matches || !modal.matches('x-modal[id^="back-in-stock-"]')) return;
    fillModal(modal);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchModals);
  } else {
    watchModals();
  }

  document.addEventListener('shopify:section:load', watchModals);
})();

(function () {
  function openFirstFaq(section) {
    if (!section) return;

    var first = section.querySelector('accordion-disclosure');
    if (!first || typeof first.open !== 'function') return;
    if (first.disclosureElement && first.disclosureElement.getAttribute('aria-expanded') === 'true') return;

    first.open({ instant: true });
  }

  function openFaqSections(root) {
    var scope = root && root.querySelectorAll ? root : document;

    if (scope.matches && scope.matches('.shopify-section--faq')) {
      openFirstFaq(scope);
      return;
    }

    scope.querySelectorAll('.shopify-section--faq').forEach(openFirstFaq);
  }

  function boot() {
    openFaqSections(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    openFaqSections(event.target);
  });
})();
